import createHttpClient from './httpClient'

const baseUrl = new URL('/api/v1/frauds/admin', process.env.VUE_APP_PUBLIC_SERVICE_BASE_URL).href
const httpClient = createHttpClient(baseUrl)

const FraudsApi = {
  /**
   * Get flagged call QA results
   * @returns {Promise}
   */
  getResults() {
    return httpClient.get('/')
  },

  /**
   * Get a single call QA result with full analytics data
   * @param {string} id
   * @returns {Promise}
   */
  getResultById(id) {
    return httpClient.get(`/${id}`)
  },

  /**
   * Update the review status of a flagged call
   * @param {string} id
   * @param {string} status - 'Addressed' or 'Ignored'
   * @returns {Promise}
   */
  async updateStatus(id, status) {
    return httpClient.patch(`/${id}/status`, { status })
  },
}

export default FraudsApi
